import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadModal/assets/arrow-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadModal/assets/PhonePreviewDesktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadModal/assets/PhonePreviewMobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadSection/assets/mobilePhonePreview.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BiggestCatchDownloadSection"] */ "/app/src/components/BiggestCatchDownloadSection/BiggestCatchDownloadSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/ExternalLink/ExternalLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FishingReportsGrid"] */ "/app/src/components/FishingReportsGrid/FishingReportsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FishingWatersGrid"] */ "/app/src/components/FishingWatersGrid/FishingWatersGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationSafeDate"] */ "/app/src/components/HydrationSafeDate/HydrationSafeDate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroMapSection"] */ "/app/src/components/Maps/components/HeroMap/HeroMapSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageNavigation"] */ "/app/src/components/Navigation/PageNavigation/PageNavigation.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/NextImage/NextImageWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegulationSection"] */ "/app/src/components/Regulations/RegulationSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopSpeciesSection"] */ "/app/src/components/TopSpeciesSection/TopSpeciesSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/TrophyWatersAppDownloadSection/assets/trophyCatches-desktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/TrophyWatersAppDownloadSection/assets/trophyCatches-mobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/helpers/errorHandling/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/app/src/views/Region/components/FAQSection/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecommendedWatersSection"] */ "/app/src/views/Region/components/RecommendedWatersSection/RecommendedWatersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StateRecordsSection"] */ "/app/src/views/Region/components/StateRecordsSection/StateRecordsSection.tsx");
